import { Button } from "components/DesignSystem/Button/Button";
import { FilterTab } from "components/DesignSystem/FilterTab/FilterTab";
import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import { PurchaseAllFiling } from "components/home/TaxComponents/PurchaseAllFiling";
import { CLICKED_PAY_AND_LAUNCH_ON_FILINGS } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { useQuery } from "hooks/useQuery";
import { useGetTaxHomePageStatsQuery } from "store/apis/taxHome";

export const PayForAllRequiredFilings = ({
  allSeasons,
  isSelected,
  handleClick,
  isFetching,
  paymentPendingCount,
}: {
  allSeasons: string;
  isSelected: boolean;
  handleClick: () => void;
  isFetching: boolean;
  paymentPendingCount: number;
}) => {
  const query = useQuery();
  const selectedSeason = query.get("season");
  const { uuid: groupId } = useCurrentGroupContext();
  const purchaseAllFilingModal = useModal();
  const { trackEvent } = useAnalytics();

  const { data: taskStats, isLoading } = useGetTaxHomePageStatsQuery(
    {
      season:
        !selectedSeason || selectedSeason === "all"
          ? allSeasons
          : selectedSeason!,
      groupId,
    },
    { skip: !groupId || !(selectedSeason || allSeasons) }
  );

  const handlePayClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    trackEvent(CLICKED_PAY_AND_LAUNCH_ON_FILINGS, {
      payment_pending_count: paymentPendingCount,
    });
    purchaseAllFilingModal.open();
  };

  return (
    <>
      <FilterTab
        isSelected={isSelected}
        onClick={handleClick}
        classNames="t-min-w-fit t-flex-1 t-w-auto sm:t-flex-none sm:t-whitespace-nowrap sm:t-px-3 sm:t-py-2"
      >
        <div className="t-flex t-gap-8 t-justify-between t-items-center sm:t-gap-2">
          <div className="t-space-y-1 sm:t-flex sm:t-items-center sm:t-gap-2 sm:t-space-y-0">
            <div className="t-text-subtext-sm t-text-text-30">
              Payment Pending
            </div>
            <div className="t-text-subtext t-text-text-100 sm:t-text-subtext-sm">
              {isFetching ? (
                <Skeleton className="t-h-6 t-w-16 t-rounded-md sm:t-h-4 sm:t-w-8" />
              ) : (
                paymentPendingCount
              )}
            </div>
          </div>
          {paymentPendingCount > 0 && (
            <Button
              size="xsmall"
              customType="primary"
              onClick={handlePayClick}
              isLoading={isLoading}
              disabled={isLoading}
            >
              Pay & launch
            </Button>
          )}
        </div>
      </FilterTab>
      {taskStats?.entities && <PurchaseAllFiling {...purchaseAllFilingModal} />}
    </>
  );
};
